import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { VendorService } from '../proxy/controlling/controllers/vendor.service';
import { LocationService } from '@planning/proxy/planning/controllers';
// import { LocationService } from '../proxy/controlling/controllers/property-location.service';

FieldBuilder.setNamespace('Controlling');

export const PROPERTYNURSERYVENDOR_FIELDS: FieldDefinition[] = [
  FieldBuilder.foreignKey(
    'vendorId',
    'Entity.Vendor',
    VendorService
  )
    .required()
    .displayFromNested('vendor.fantasyName')
    .sortBy('vendor.fantasyName')
    .build(),
  FieldBuilder.foreignKey(
    'propertyLocationId',
    'Entity.PropertyNurseryVendor.PropertyLocation',
    LocationService
  )
    .required()
    .display('name')
    .keyField('id')
    .build(),
];

export const PROPERTYNURSERYVENDOR_CONFIG = {
  entityName: 'PropertyNurseryVendor',
  localizationKey: 'Controlling::Entity.PropertyNurseryVendor',
  fields: PROPERTYNURSERYVENDOR_FIELDS,
  permission: 'Silviculture.PropertyNurseryVendors',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Silviculture + MENU_NAME_SUFFIX,
  menuSubcategory: undefined,
};
